import React, { useEffect, useState, useRef } from "react";
import geojson from './usa-topo.json';
import Dropdown from "../../util/Dropdown";
import { feature } from "topojson-client"
import stateAbbrs from './us-abbr.json';
import * as d3 from "d3";
import './map.css'
import * as analytics from "../../util/Analytics/MapAnalytics";


let mapObject = null;
const Map = ({ tableData, sideFilterSelection, card, stratificationID, }) => {


    const classificationTyes = [
        { text: 'Quantile', value: 'Quantile' },
        { text: 'Equal Interval', value: 'EqualInterval' },
        { text: 'Natural Breaks', value: 'NaturalBreak' },
        { text: 'Geometric Interval', value: 'GeometricInterval' }
    ]

    const mapRef = useRef(null);
    const zoomInRef = useRef(null);
    const zoomOutRef = useRef(null);
    const zoomResetRef = useRef(null);

    const legendRef = useRef(null);
    const toolTipRef = useRef(null);
    const toolTipCloseRef = useRef(null);
    const toolTipLinkRef = useRef(null);



    const [classificationType, setClassificationType] = useState(classificationTyes[0].value);// useState("Quantile");
    //const [invalidKeyData, setInvalidKeyData] = useState(false);
    const [classNumber, setClassNumber] = useState(4);
    const legendData = BuildLegendDropdowns();


    const filteredClassificationTypes = legendData ? legendData.filteredClassificationTypes : [];

    const filteredClassNumbers = legendData ? legendData.filteredClassNumbers : null

    //const [filteredClassNumbers, setFilteredClassNumbers] = useState([]);
    //const [filteredClassificationTypes, setFilteredClassificationTypes] = useState([]);




    //const classNumber = legendData ? legendData.initialClassNumber : null;

    //const classificationType = legendData ? legendData.filteredClassNumbers : null;


    const dataValueType = tableData.DataItems[0].DataValueType
    const dataValueUnit = tableData.DataItems[0].DataValueUnit
    const DataValueUnit = dataValueType === "Number" || dataValueUnit === "gallons" ? "" : "(" + dataValueUnit + ")";




    useEffect(() => {

        //const legendData = BuildLegendDropdowns();

        if (legendData) {
            InitializeMapData(legendData);
        }

    }, [tableData, stratificationID, classificationType, classNumber]);

    const tempKeyItems = legendData ? tableData.StratificationKeyItems.filter(function (StratificationKeyItem) {
        return StratificationKeyItem.StratificationID === stratificationID && StratificationKeyItem.ClassNumber === legendData.initialClassNumber && StratificationKeyItem.ClassificationType === classificationType;
    }) : null;;

    const Class1 = tempKeyItems && tempKeyItems.length > 0 && tempKeyItems[0].KeyItems.length > 0 ? tempKeyItems[0].KeyItems[0].Items : [];
    const Class2 = tempKeyItems && tempKeyItems.length > 0 && tempKeyItems[0].KeyItems.length > 1 ? tempKeyItems[0].KeyItems[1].Items : [];
    const Class3 = tempKeyItems && tempKeyItems.length > 0 && tempKeyItems[0].KeyItems.length > 2 ? tempKeyItems[0].KeyItems[2].Items : [];
    const Class4 = tempKeyItems && tempKeyItems.length > 0 && tempKeyItems[0].KeyItems.length > 3 ? tempKeyItems[0].KeyItems[3].Items : [];
    const Class5 = tempKeyItems && tempKeyItems.length > 0 && tempKeyItems[0].KeyItems.length > 4 ? tempKeyItems[0].KeyItems[4].Items : [];





    const StratkeyItems = tempKeyItems && tempKeyItems.length > 0 ? tempKeyItems[0].KeyItems : null;
    const invalidKeyData = tempKeyItems ? false : true;





    async function InitializeMapData(legendData) {

        ClearLocationToolTip();

        if (legendData) {

            //await setStratification(stratificationID);
            //await setClassificationType(legendData.initialClassificationType);
            //await setFilteredClassificationTypes(legendData.filteredClassificationTypes);
            //await setFilteredClassNumbers(legendData.filteredClassNumbers);
            //await setClassNumber(legendData.initialClassNumber);



            mapObject = ShowMap(geojson, id, legendData.initialClassNumber);

        } else {

            //setStratification(stratificationID);
            //setClassificationType(null);
            //setFilteredClassificationTypes(null);
            //setFilteredClassNumbers(null);
            //setClassNumber(null);
            ////setStratkeyItems(null);
            //mapObject = ShowMap(geojson, id, 0);
        }
    }

    function BuildLegendDropdowns() {
        let index = 0;

        let initialClassificationType = classificationTyes[index].value;


        const filterItems = tableData.StratificationKeyItems.filter(x => !x.HasError && x.StratificationID === stratificationID);

        if (classNumber || classificationType) {
            return getLegendItem(filterItems, classificationType, classNumber);
        }

        let output = null;

        //initial check. if no items, we can't calculate
        if (!filterItems || filterItems.length === 0) return null;

        for (index = 0; index < classificationTyes.length; index++) {

            //put this into a function so that it can be called fora  single classification type and number of classes
            initialClassificationType = classificationTyes[index].value;

            output = getLegendItem(filterItems, initialClassificationType);

            if (output !== null) break;
        }
        return output;
    }

    function getLegendItem(filterItems, initialClassificationType, initialClassNumber) {
        let filteredClassificationTypes = [];
        let filteredClassNumbers = []

        const distinctClassificationTypes =
            filterItems && filterItems.length > 0
                ? filterItems.filter((value, index, self) => {
                    return (
                        self.findIndex((v) => v.ClassificationType === value.ClassificationType) === index
                    );
                })
                : [];

        filteredClassificationTypes = distinctClassificationTypes && distinctClassificationTypes.length > 0 && distinctClassificationTypes.map((item, index) => {
            return classificationTyes.filter(x => x.value === item.ClassificationType)[0];
        });

        if (!filteredClassificationTypes || filteredClassificationTypes.length === 0) return null;

        filteredClassNumbers = filterItems && filterItems.length > 0 && filterItems.filter(x => x.ClassificationType === initialClassificationType).map((item, index) => {
            return { text: item.ClassNumber, value: item.ClassNumber };
        });

        if (!filteredClassNumbers || filteredClassNumbers.length === 0) return null;


        initialClassNumber = initialClassNumber ? initialClassNumber : (filteredClassNumbers && filteredClassNumbers.length === 4 ? filteredClassNumbers[filteredClassNumbers.length - 2].value : (filteredClassNumbers.length > 0 ? filteredClassNumbers[filteredClassNumbers.length - 1].value : 0));

        if (initialClassNumber === 0 || filteredClassNumbers.length === 0 || filteredClassificationTypes.length === 0) return null;

        return { filteredClassificationTypes: filteredClassificationTypes, filteredClassNumbers: filteredClassNumbers, initialClassNumber: Number(initialClassNumber), initialClassificationType: initialClassificationType }
    }

    const smallStateIds = ['10', '11', '44'];
    const territoryIds = ['66', '72', '78'];

    const colorNoData = "#bdbdbd";
    const textNoData = "#000000"
    const territories = [{
        "id": "66",
        "properties": { "name": "Guam" }
    },
    {
        "id": "72",
        "properties": { "name": "Puerto Rico" }
    },
    {
        "type": "MultiPolygon",
        "arcs": [

        ],
        "id": "78",
        "properties": { "name": "Virgin Islands" }
    },

    ];

    //class 6 and 7 are not used
    const Class_7 = [
        { color: '#a7f4e4', text: '#000000' },
        { color: '#8edccc', text: '#000000' },
        { color: '#75c4b4', text: '#000000' },
        { color: '#5dac9d', text: '#000000' },
        { color: '#449587', text: '#000000' },
        { color: '#297f71', text: '#FFFFFF' },
        { color: '#00695c', text: '#FFFFFF' },
    ]

    const Class_6 = [
        { color: '#a7f4e4', text: '#000000' },
        { color: '#8edccc', text: '#000000' },
        { color: '#75c4b4', text: '#000000' },
        { color: '#5dac9d', text: '#000000' },
        { color: '#449587', text: '#000000' },
        { color: '#00695c', text: '#FFFFFF' },
    ]
    const Class_5 = [
        { color: '#c9e1ec', text: 'black' },
        { color: '#a2c8d9', text: 'black' },
        { color: '#7bafc6', text: 'black' },
        { color: '#4f97b3', text: 'black' },
        { color: '#0080a1', text: 'white' },
    ]

    const Class_4 = [
        { color: '#c9e1ec', text: 'black' },
        { color: '#a2c8d9', text: 'black' },
        { color: '#4f97b3', text: 'black' },
        { color: '#0080a1', text: 'white' }
    ]
    const Class_3 = [
        { color: '#c9e1ec', text: 'black' },
        { color: '#7bafc6', text: 'black' },
        { color: '#0080a1', text: 'white' },
        
        
    ]
    const Class_2 = [        
        { color: '#c9e1ec', text: 'black' },
        { color: '#0080a1 ', text: 'white' },
    ]


    const colorsArray = [Class_2, Class_3, Class_4, Class_5, Class_6, Class_7]



    let bottom = null;



    const [showToolTip, setShowToolTip] = useState(false);
    const [hover_x, setHoverX] = useState(0);
    const [hover_y, setHoverY] = useState(0);

    const [locationText, setLocationText] = useState("");
    const [url, setUrl] = useState("");
    const [urlText, setUrlText] = useState("");
    const [headerText, setPopupHeaderText] = useState("");

    const [popupHeaderTextColor, setPopupHeaderTextColor] = useState("");
    const [popupHeaderBackgroundColor, setPopupHeaderBackgroundColor] = useState("");

    const [ciDisplay, setCIDisplay] = useState("");

    //const [StratkeyItems, setStratkeyItems] = useState([]);



    const id = card ? "map_" + card.QuestionId : "";

    function getColor(id, classNumber) {


        if (Class1.includes(id) && classNumber >= 2) {
            return colorsArray[classNumber - 2][0].color
        }
        else if (Class2.includes(id) && classNumber >= 2) {
            return colorsArray[classNumber - 2][1].color
        }
        else if (Class3.includes(id) && classNumber >= 3) {
            return colorsArray[classNumber - 2][2].color
        }
        else if (Class4.includes(id) && classNumber >= 4) {
            return colorsArray[classNumber - 2][3].color
        }
        else if (Class5.includes(id) && classNumber >= 5) {
            return colorsArray[classNumber - 2][4].color
        }
        else {

            return colorNoData
        }
    }
    function getTextColor(id, classNumber) {
        if (Class1.includes(id) && classNumber >= 2) {
            return colorsArray[classNumber - 2][0].text
        }
        else if (Class2.includes(id) && classNumber >= 2) {
            return colorsArray[classNumber - 2][1].text
        }
        else if (Class3.includes(id) && classNumber >= 3) {
            return colorsArray[classNumber - 2][2].text
        }
        else if (Class4.includes(id) && classNumber >= 4) {
            return colorsArray[classNumber - 2][3].text
        }
        else if (Class5.includes(id) && classNumber >= 5) {
            return colorsArray[classNumber - 2][4].text
        }
        else {

            return textNoData
        }
    }
    function hasMapData(locationAbbr) {

        if (Class1.includes(locationAbbr)) return true;
        if (Class2.includes(locationAbbr)) return true;
        if (Class3.includes(locationAbbr)) return true;
        if (Class4.includes(locationAbbr)) return true;
        if (Class5.includes(locationAbbr)) return true;
        return false;
    }
    function HandleClassificationTypeChange(classificationType) {
        setClassificationType(classificationType.value);
        analytics.selectMapClassification({ classificationType: classificationType.value })
        //const legendData = BuildLegendDropdowns({ classificationType: classificationType.value, classNumber: classNumber });
        //InitializeMapData(legendData);
    }
    function HandleClassNumberChange(classNumber) {
        setClassNumber(parseInt(classNumber.value))
        analytics.selectMapClasses({ numberOfClasses: classNumber.value });


        //const legendData = BuildLegendDropdowns({ classificationType: classificationType, classNumber: classNumber.value });
        //InitializeMapData(legendData);
    }



    const [stateIndex, setStateIndex] = useState(0);
    const [isFirst, setIsFirst] = useState(true);

    function handleBlur(event) {
        var itemList = mapRef.current?.querySelectorAll(".state-text");

        itemList.forEach((item, i) => {
            item.classList.remove("map-focus");
        });
        //setStateIndex(0);
        //setIsFirst(true);
        //mapRef.current?.setAttribute('aria-activedescendant', "");
    }
    function handletooltipKeyDown(event) {
        event.preventDefault();
        var itemList = mapRef.current?.querySelectorAll(".state-text");
        if (event.code === "Enter" || event.code === "Escape") {
            hideToolTip();
            mapRef.current?.parentNode.focus();

            itemList[stateIndex].classList.add("map-focus");
            itemList[stateIndex].focus();
        }
        else if (event.code === "Tab") {
            toolTipLinkRef.current?.focus();
        }
        else {
            return false;
        }
    }
    function handleToolTipLinkKeyDown(event) {

        var itemList = mapRef.current?.querySelectorAll(".state-text");
        if (event.code === "Escape") {
            event.preventDefault();
            hideToolTip();
            mapRef.current?.parentNode.focus();

            itemList[stateIndex].classList.add("map-focus");
            itemList[stateIndex].focus();
        }
        if (event.code === "Enter") {

            handleMapIndicatorLinkClick();
        }
        else if (event.code === "Tab") {
            event.preventDefault();
            toolTipCloseRef.current?.focus();
        }
        else {
            event.preventDefault();
            return false;
        }
    }


    function getAriaTextForMapLocation(d, i, locationCode) {
        const locations = tableData.DataItems.filter((x) => x.LocationAbbr === locationCode);
        const locationText = locations && locations.length > 0 ? locations[0].LocationDesc : null;

        if (locationText !== null) {

            const items = tableData.DataItems.filter((x) => x.LocationAbbr === locationCode && x.StratificationID === stratificationID);
            if (items.length > 0 && items[0].DataValue !== null) {
                return "Select to see data for " + locationText;
            }
            else {
                return "Data not available for " + locationText;
            }
        }
        else {

            return "Unknown State or Territory"
        }
    }
    function handleKeyDown(event) {
        var itemList = mapRef.current?.querySelectorAll(".state-text");
        if (event.code === "Tab" && event.shiftKey) {
            //nothing. let's just catch it
        }
        else if (event.code === "End") {
            event.preventDefault();
            let nextIndex = null;
            if (isFirst) {
                nextIndex = 0;
                setIsFirst(false);
            } else {
                nextIndex = itemList.length - 1;
            }


            itemList.forEach((item, i) => {
                item.setAttribute("aria-selected", "false");
                item.classList.remove("map-focus");
            });

            itemList[nextIndex].classList.add("map-focus");
            itemList[nextIndex].focus();

            itemList[nextIndex].setAttribute("aria-selected", "true");
            setStateIndex(nextIndex);


        }
        else if (event.code === "Home") {
            event.preventDefault();
            let nextIndex = null;
            if (isFirst) {
                nextIndex = 0;
                setIsFirst(false);
            } else {
                nextIndex = 0;
            }


            itemList.forEach((item, i) => {
                item.setAttribute("aria-selected", "false");
                item.classList.remove("map-focus");
            });

            itemList[nextIndex].classList.add("map-focus");
            itemList[nextIndex].focus();

            itemList[nextIndex].setAttribute("aria-selected", "true");
            setStateIndex(nextIndex);



        }
        else if (event.code !== "Tab") {
            event.preventDefault();
            if (event.code === "ArrowDown") {
                console.log("arrow down");

                let nextIndex = null;
                if (isFirst) {
                    nextIndex = 0;
                    setIsFirst(false);
                } else {
                    nextIndex = stateIndex + 1;
                }

                if (nextIndex < itemList.length) {
                    itemList.forEach((item, i) => {
                        item.setAttribute("aria-selected", "false");
                        item.classList.remove("map-focus");
                    });

                    itemList[nextIndex].classList.add("map-focus");
                    itemList[nextIndex].focus();
                    itemList[nextIndex].setAttribute("aria-selected", "true");
                    setStateIndex(nextIndex);
                }
            } else if (event.code === "ArrowUp") {
                console.log("arrow up");

                let nextIndex = null;
                if (isFirst) {
                    nextIndex = 0;
                    setIsFirst(false);
                } else {
                    nextIndex = stateIndex - 1;
                }
                if (nextIndex > -1) {
                    itemList.forEach((item, i) => {
                        item.setAttribute("aria-selected", "false");
                        item.classList.remove("map-focus");
                    });
                    itemList[nextIndex].setAttribute("aria-selected", "true");
                    itemList[nextIndex].classList.add("map-focus");
                    itemList[nextIndex].focus();

                    setStateIndex(nextIndex);
                }
            } else if (event.code === "Enter") {

                ShowToolTip(itemList[stateIndex], itemList[stateIndex].id, true);
            }
        }
    }



    function ShowMap(mapdata, id, classNumber) {

        const width = 1500,
            height = 800;

        //remove a prior instance
        d3.select("svg").remove();

        let svg = d3.select("#" + id).append("svg")
            .attr("width", width)
            .attr("height", height)
            .attr("viewBox", [-100, 0, width, height])
            .attr("style", "width: 100%; height: auto; height: intrinsic;");

        let g = svg.append("g");
        g.attr("id", "map")
        g.attr("class", "states")
            .selectAll("path")
            .data(feature(mapdata, mapdata.objects.states).features)
            .join('path')
            .attr('d', d3.geoPath())
            .attr('stroke', 'lightgrey')
            .attr('fill', 'grey')
            .style("stroke-width", function (d) {
                return 2;
            })
            .style("fill", function (d) {
                return getColor(stateAbbrs[d.id], classNumber);
            })
            .on('mouseover', function (d, i) {
                d.currentTarget.classList.add('hovered');
            })
            .on("mouseout", function (d) {
                d.currentTarget.classList.remove('hovered');
            })
            .on('click', function (d, i) {
                d.currentTarget.classList.add('hovered');
                ShowToolTip(d, stateAbbrs[i.id]);
            })


        g.append("g").attr("id", "labels")
        g.selectAll("text")
            .data(feature(mapdata, mapdata.objects.states).features)
            .join('text')
            .attr("class", "state-text")
            .attr("aria-selected", "false")
            .attr("role", "option")
            .attr("id", function (d) {
                return stateAbbrs[d.id];
            })
            .attr("aria-label", function (d, i) {
                return getAriaTextForMapLocation(d, i, stateAbbrs[d.id]);
            })

            .attr("text-anchor", "middle")
            .style('font-size', '18px')
            .style('font-weight', '50')
            .text(function (d) {
                return d.id !== '44' && d.id !== '10' && d.id !== '11' && d.id !== '66' && d.id !== '72' && d.id !== '78' ? stateAbbrs[d.id] : "";
            })
            .style("fill", function (d) {
                return getTextColor(stateAbbrs[d.id], classNumber);
            })
            .attr("x", function (d) {
                let extraX = 0
                if (d.id === 12) extraX = 10;
                if (d.id === 22) extraX = -10;
                if (d.id === 26) extraX = 5;
                return d3.geoPath().centroid(d)[0] + extraX;
            })
            .attr("y", function (d) {
                let extraY = 0;
                if (d.id === 21) extraY = 5;
                if (d.id === 26) extraY = 20;
                if (d.id === 47) extraY = 5;
                return d3.geoPath().centroid(d)[1] + extraY;
            })
            .on('click', function (d, i) {

                ShowToolTip(d, stateAbbrs[i.id]);
            })



        var element = document.getElementById(id) ? document.getElementById(id) : null;
        var c = element ? element.getBoundingClientRect() : null;
        bottom = c && c.bottom ? c.bottom : 0;

        const smallState_x = 920;
        const smallState_y = 150;
        const smallState_width = 65;
        const smallState_height = 40;

        smallStateIds.forEach((stateId, index) => {

            g.append('g').attr("class", "states")
                .append("rect")
                .attr("class", "states")
                .attr("x", smallState_x)
                .attr("y", smallState_y + ((index + 1) * 60))
                .attr("width", smallState_width)
                .attr("height", smallState_height)
                .style("fill", function (d) {
                    return getColor(stateAbbrs[stateId], classNumber);
                })
                .attr("rx", 5)
                .attr("ry", 5)
                .style("stroke", "grey")
                .style("stroke-width", function (d) {
                    return 1.5;
                })
                .on('click', function (d, i) {
                    d.currentTarget.classList.add('hovered');
                    ShowToolTip(d, stateAbbrs[stateId], false);
                })

            g.append('g').attr("class", "states")
                .append("text")
                .attr("class", "state-text")
                .attr("aria-selected", "false")
                .attr("role", "option")
                .attr("id", function (d) {
                    return stateAbbrs[stateId];
                })
                .attr("aria-label", function (d, i) {
                    return getAriaTextForMapLocation(d, i, stateAbbrs[stateId]);
                })

                .attr("x", smallState_x + 30)
                .attr("y", smallState_y + 25 + ((index + 1) * 60))
                .text(stateAbbrs[stateId])
                .attr("text-anchor", "middle")
                .style('font-size', '18px')
                .style('font-weight', '50')
                .attr('stroke', getTextColor(stateId, classNumber))
                .on('click', function (d, i) {
                    d.currentTarget.classList.add('hovered');
                    ShowToolTip(d, stateAbbrs[stateId], false);
                })


        })

        const smallTerritory_x = 0;
        const smallTerritory_y = 650;
        const smallTerritory_width = 65;
        const smallTerritory_height = 40;

        territoryIds.forEach((stateId, index) => {

            g.attr("class", "states")
                .append("rect")
                .attr("x", smallTerritory_x + ((index + 1) * 75))
                .attr("y", smallTerritory_y)
                .attr("rx", 5)
                .attr("ry", 5)
                .style("stroke", "grey")
                .style("stroke-width", function (d) {
                    return 1.5;
                })
                .attr("width", smallTerritory_width)
                .attr("height", smallTerritory_height)
                .style("fill", function (d) {
                    return getColor(stateAbbrs[stateId], classNumber);
                })
                .style("stroke", "grey")

                .on('click', function (d, i) {
                    d.currentTarget.classList.add('hovered');
                    ShowToolTip(d, stateAbbrs[stateId], false);
                })
            g.attr("class", "states")
                .append("text")
                .attr("class", "state-text")
                .attr("aria-selected", "false")
                .attr("role", "option")
                .attr("id", function (d) {
                    return stateAbbrs[stateId];
                })
                .attr("aria-label", function (d, i) {
                    return getAriaTextForMapLocation(d, i, stateAbbrs[stateId]);
                })
                .attr("x", smallTerritory_x + 30 + ((index + 1) * 75))
                .attr("y", smallTerritory_y + 25)
                .text(stateAbbrs[stateId])
                .attr("text-anchor", "middle")
                .style('font-size', '18px')
                .style('font-weight', '50')
                .attr('stroke', getTextColor(stateId, classNumber))
                .on('click', function (d, i) {
                    d.currentTarget.classList.add('hovered');
                    ShowToolTip(d, stateAbbrs[stateId], false);

                })
        })

        function zoomed({ transform }) {
            g.attr("transform", transform);
        }

        const zoom = d3.zoom()
            .scaleExtent([1, 40])
            .on("zoom", zoomed);

        svg.call(zoom);


        d3.select(zoomInRef.current).on('click', function () {
            zoom.scaleBy(svg.transition().duration(500), 2);
        });

        d3.select(zoomOutRef.current).on('click', function () {
            zoom.scaleBy(svg.transition().duration(500), .5);
        });

        d3.select(zoomResetRef.current).on('click', function () {
            svg.transition().duration(750).call(zoom.transform, d3.zoomIdentity, d3.zoomTransform(svg.node()).invert([width / 2, height / 2]))
        });
    }

    function ClearLocationToolTip() {
        setLocationText("Data unavailable")
        setCIDisplay("")
        setHoverX(0);
        setHoverY(0);
        setShowToolTip(false);
    }

    async function ShowToolTip(d, locationCode, isEnterKey = false) {

        analytics.selectMapSelection();

        //we have no d, so lets clear and hide
        if (d == null) {
            ClearLocationToolTip();
            return;
        }

        //get location item
        const filteredTableData = tableData.DataItems.filter(function (DataItem) {
            return DataItem.LocationAbbr === locationCode && DataItem.StratificationID === stratificationID;
        });
        const item = filteredTableData && filteredTableData.length && filteredTableData.length === 1 ? filteredTableData[0] : null;

        //we have an item from the dataset
        if (item) {
            const LocationName = item.LocationDesc;
            const LocationAbbr = item.LocationAbbr;
            const DataValueUnitForToolTip = item.DataValueUnit;

            const DataValue = item.DataValueDisplay !== null ? item.DataValueDisplay : "Data unavailable";
            const LowConfidenceLimit = item.LowConfidenceLimitDisplay ? item.LowConfidenceLimitDisplay : null;
            const HighConfidenceLimit = item.HighConfidenceLimitDisplay ? item.HighConfidenceLimitDisplay : null;
            const DataValueFootnoteSymbol = item.DataValueFootnoteSymbol ? item.DataValueFootnoteSymbol : "";
            const CIDisplay = LowConfidenceLimit && HighConfidenceLimit ? "95% CI (" + LowConfidenceLimit + " - " + HighConfidenceLimit + ")" : "";
            const headerText = LocationName;
            const url = `?location=${item.LocationAbbr}&category=${card.TopicId}&indicators=ALL`

            const urlText = "View all indicators for " + LocationAbbr;

            setPopupHeaderTextColor(getTextColor(locationCode, classNumber));
            setPopupHeaderBackgroundColor(getColor(locationCode, classNumber));

            setLocationText(LocationName + ": " + DataValue + " " + DataValueUnitForToolTip);
            setUrl(url);
            setUrlText(urlText);
            setPopupHeaderText(headerText);
            setCIDisplay(CIDisplay + " " + DataValueFootnoteSymbol);
        }
        else if (locationCode) {//we have an id but no record. Lets get the location name and set data unavailable
            let jsonLocation = geojson.objects.states.geometries.filter(function (item) {
                return item.id === locationCode;
            });

            if (!jsonLocation || jsonLocation.length === 0) {
                jsonLocation = territories.filter(function (item) {
                    return item.id === locationCode;
                });
            }

            const location = jsonLocation && jsonLocation.length > 0 ? jsonLocation[0].properties.name : "";
            setLocationText(location + ": Data unavailable")
            setCIDisplay("")
        }
        else { //lets just clear
            ClearLocationToolTip();
        }
        await setHoverY(d.layerY);
        await setShowToolTip(true);
        await setHoverX(getHoverX(d));

        const legendBounds = legendRef.current.getBoundingClientRect();
        const toolTipBounds = toolTipRef.current.getBoundingClientRect();

        const windowBottom = window.innerHeight || document.documentElement.clientHeight;

        //quick collision check with bottom of screen and legend
        if (toolTipBounds.right > legendBounds.left) {
            const leftShift = toolTipBounds.right > legendBounds.left ? toolTipBounds.right - legendBounds.left : 0
            await setHoverX(getHoverX(d, leftShift + 25));
        }
        if (toolTipBounds.bottom > windowBottom) {
            const bottomShift = toolTipBounds.bottom - windowBottom;
            await setHoverY(d.layerY - bottomShift - 25);
        }

        if (isEnterKey) {
            toolTipCloseRef.current?.focus();
        }
    }
    function hideToolTip() {
        setShowToolTip(false);
    }
    function getHoverX(d, leftShift) {
        if (leftShift) return d.layerX - leftShift;
        return d.layerX;
    }

    function handleMapIndicatorLinkClick() {
        analytics.selectMapIndicatorLink();
    }

    return (
        <div className="text-center map-toolTipContainer pb-0 mb-0">
            <div className="ToolTipContainer p-0 m-0" id={"tooltip_" + id} hidden={showToolTip ? "" : "hidden"} style={{ top: hover_y + "px", left: hover_x + "px" }} ref={toolTipRef}>
                <div className="ToolTipHeader p-0 m-0 row" style={{ backgroundColor: popupHeaderBackgroundColor }}>
                    <div className="col col-9 header-text p-1 ml-1" style={{ color: popupHeaderTextColor }}>{headerText}</div>
                    <div className="col text-right">
                        <button
                            ref={toolTipCloseRef}
                            onKeyDown={handletooltipKeyDown}
                            tabIndex="0"
                            onClick={hideToolTip}
                            style={{ color: popupHeaderTextColor }}
                            className="btn btn-link close-button p-0 m-0"
                            aria-label="Close modal">Close</button></div>

                </div>
                <div className="m-2">
                    <div className="ToolTipLocation m-1">{locationText}</div>
                    <div className="ToolTipCI m-1">{ciDisplay}</div>
                    <div className="ToolTipLink m-1"><a
                        onKeyDown={handleToolTipLinkKeyDown}
                        tabIndex="0"
                        ref={toolTipLinkRef} onClick={handleMapIndicatorLinkClick} href={url}>{urlText}</a></div>
                </div>
            </div>


            {invalidKeyData &&
                <div className="text-center mt-4">
                    No map data to show.
                </div>

            }
            <div onKeyDown={handleKeyDown} className="mt-3"
                tabIndex="0"
                onBlur={handleBlur}
                role="listbox"
                aria-label="United States Map and Territories"
                aria-describedby={"keyItems_" + id}
                aria-keyshortcuts="ArrowUp,ArrowDown,Home,End"
            >
                
                <div ref={mapRef} id={id}></div>
            </div>
            <div id={"MapZoom_" + id} className="MapZoomContainer ml-3 p-1 d-print-none" style={{ top: bottom + "px" }}>
                <div>
                    <button
                        tabIndex="0"
                        ref={zoomInRef} className="zoom-button filter-data-button btn btn-white p-1" value="zoomIn" style={{ "border": "1px solid  #bdbdbd", "color": "#00695c" }} ><span className="cdc-icon-plus"></span><p className='sr-only'>plus</p> </button>
                </div>
                <div>
                    <button ref={zoomOutRef} className="zoom-button filter-data-button btn btn-white p-1" value="zoomOut" style={{ "border": "1px solid  #bdbdbd", "color": "#00695c" }} ><span className="cdc-icon-minus"></span><p className='sr-only'>minus</p></button>
                </div>
                <div>
                    <button ref={zoomResetRef} className="zoom-button filter-data-button btn btn-white p-1" value="zoomReset" style={{ "border": "1px solid  #bdbdbd", "color": "#00695c" }}><span className="cdc-icon-replay"></span><p className='sr-only'>reset</p></button>
                </div>
            </div>


            <div id={"keyItems_" + id} className="LegendContainer print-move-right map-mobile-scale" ref={legendRef} aria-label="Legend">
                <div className="LegendItemHeader p-2">{sideFilterSelection && sideFilterSelection.DataValueType}<br /> {DataValueUnit}</div>
                <div className="ClassesContainer p-2">
                    {StratkeyItems && StratkeyItems.length > 0 && StratkeyItems.map((item, index) => {
                        console.log("classNumber: " + classNumber);
                        const i = StratkeyItems[index] ? StratkeyItems[index] : null;
                        const itemText = i ? i.LowValueDisplay+ ' - ' + i.HighValueDisplay : "Data Unavailable";
                        const color = colorsArray && colorsArray[classNumber - 2] && colorsArray[classNumber - 2][index].color ? colorsArray[classNumber - 2][index].color : "pink"

                        return (
                            <div className="LegendItem">
                                <span className="dot" style={{ backgroundColor: color }}></span>
                                <span>{itemText}</span>
                            </div>
                        );
                    })}

                    <div className="LegendItem">
                        <span className="dot" style={{ backgroundColor: colorNoData }}></span>
                        <span>Data Unavailable</span>
                    </div>
                </div>
                <div className="ClassificationTypeContainer LegendItemContainer pl-2 pr-2">
                    {filteredClassificationTypes && filteredClassificationTypes.length > 0 &&
                        <Dropdown
                            itemID="value"
                        itemName="text"
                            
                            options={filteredClassificationTypes}
                            dropdownTitle="Classification Type"
                            dropdownID={"btnClassificationType"}
                            value={classificationType}
                            OnChange={HandleClassificationTypeChange}
                            showEmpty={false}
                        />
                    }
                </div>
                <div className="NumberOfClassesContainer p-2 LegendItemContainer">
                    {filteredClassNumbers && filteredClassNumbers.length > 0 &&
                        <Dropdown
                            itemID="value"
                            itemName="text"
                            options={filteredClassNumbers}
                            dropdownTitle="Number of Classes"
                            dropdownID={"btnClassificationCount"}
                            value={classNumber}
                            OnChange={HandleClassNumberChange}
                            showEmpty={false}
                        />
                    }
                </div>
            </div>
        </div>)
};
export default Map;

